import React from 'react';
import { RSCheckbox } from 'reactsymbols-kit';

// reactsymbols-kit types the base component's state as `any`. We narrow the
// only field this override touches rather than re-using that `any`.
interface CheckboxState {
  checked?: boolean;
}

type CheckboxProps = React.ComponentProps<typeof RSCheckbox>;

/**
 * Subclass of reactsymbols-kit's RSCheckbox to work around a bug where the
 * checked doesn't update when the checked prop changes.
 */
class Checkbox extends RSCheckbox {
  static getDerivedStateFromProps(props: CheckboxProps, state: CheckboxState) {
    if (props.checked !== state.checked) {
      return {
        checked: props.checked,
      };
    } else {
      return null;
    }
  }
}

export default Checkbox;
